// Utils
import { assert, headOfPath, joinPaths, tailOfPath } from 'ezyvet-fe-helpers';
/**
 * Translates object based property references to path based ones ones, converting the object id
 * to the path of the object.
 * i.e. `{objectId}.{property}` to `{objectPathInDotNotation}.{property}`
 * Will throw an error if the object does not exist.
 *
 * @param {string} propertyPath
 * @param {IndexedStore<string>} objectIdToPaths
 *
 * @return {string}
 */
export var translatePropertyPath = function (propertyPath, objectIdToPaths) {
    // The head is always the object id, it's what the change is relative to
    var objectId = headOfPath(propertyPath);
    var objectPath = objectIdToPaths[objectId];
    assert(objectPath !== undefined, "The changes object for key " + propertyPath + " does not exists!");
    return joinPaths(objectPath, tailOfPath(propertyPath));
};
//# sourceMappingURL=translatePropertyPath.js.map